<template>
	<div v-if="activities" class="py-8">
		<Timeline :value="allActivities" class="-ml-[100%]">
			<template #content="slotProps">
				<HistoryTimelineCard :item="slotProps.item" :index="slotProps.index"/>
			</template>
		</Timeline>
	</div>
</template>

<script>
import { mapStores } from "pinia";
import { useRegulationsStore } from "@/stores/regulations.js";
import HistoryTimelineCard from "@/Components/HistoryTimelineCard.vue";

export default {
	name: "RegulationHistoryView",
	components: {HistoryTimelineCard},
	data() {
		return {
			activities: undefined,
		}
	},
	computed: {
		...mapStores(useRegulationsStore),
		allActivities() {
			return [
				...this.activities,
			].sort((a, b) => Date.parse(b.created_at) - Date.parse(a.created_at));
		},
	},
	methods: {
		async refreshRegulation() {
			return this.regulationsStore.showRegulation(this.$route.params.regulation, {
				fields: {regulations: 'id'},
				include: 'activities.causer',
			});
		},
	},
	watch: {
		'$route.params.regulation': {
			async handler(newValue, oldValue) {
				if (newValue) {
					if (this.$route.params.regulation === 'NEW') {
						this.activities = [];
					} else {
						const response = (await this.refreshRegulation());
						this.activities = response.activities;
					}
				} else {
					this.activities = undefined;
				}
			},
			immediate: true,
		}
	},
}
</script>
